import { render, staticRenderFns } from "./NewsFilter.vue?vue&type=template&id=1f12a5eb&"
import script from "./NewsFilter.vue?vue&type=script&lang=js&"
export * from "./NewsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports